module.exports = __webpack_public_path__ + "static/media/8765.821318fb.png";